module.exports = __webpack_public_path__ + "static/media/delete.e20f2bf0.svg";